import React from "react";
import { useTranslation } from "react-i18next";
import "./style.css";

const translationKeys: Record<string, string> = {
  "A tarefa foi concluída?": "taskCompleted", "A tarefa foi iniciada?": "taskStarted", "Qual o tipo de operação?": "operationType", "Informar horímetro inicial": "initialHourMeter", "Horímetro final": "finalHourMeter", "Informar horímetro final": "finalHourMeter", "Foi realizada conforme as especificações?": "specificationsFollowed", "Qual o tipo de transferência?": "transferType",
  "Possui forrageira?": "hasFodder", "Qual a proporção da área coberta com planta forrageira?": "fodderCoverage", "Qual a altura do capim?": "grassHeight", "Possui invasoras?": "hasWeeds", "Qual o tipo de folha?": "leafType", "Qual o tipo de invasora?": "weedType", "Qual a cobertura de invasoras?": "weedCoverage", "Nota": "rating", "Possui pragas ou doenças?": "hasPests", "Possui aguada?": "hasWaterSource", "Como é o nível de acesso?": "accessLevel", "Precisa de reparo?": "needsRepair", "Possui depósito de suplemento?": "hasSupplementStorage", "Quantos quilos cabem?": "capacityKg", "Possui cocho?": "hasTrough", "O cocho é coberto?": "coveredTrough", "Qual o tamanho em comprimento?": "length", "Qual o tamanho em largura?": "width", "Quantos lados possui o acesso desse cocho?": "troughAccessSides", "Qual a capacidade do cocho?": "troughCapacity", "Qual a quantidade de fios?": "wireQuantity",
  "Deseja criar um novo lote?": "createNewBatch", "Deseja incluir ou excluir um pasto na rota?": "updateRoute", "Esse produto está saindo de um depósito central ou do depósito desse pasto?": "productOrigin", "O destino será para um cocho ou para o depósito desse pasto?": "productDestination", "Como está o cocho?": "troughCondition", "Houve perda de produto?": "productLoss", "Você recebeu esses animais com essas especificações?": "receivedAnimals", "Quantidade de animais recebidos": "receivedAnimalQuantity", "Vivo ou para abate?": "saleType", "Recebeu o Produto?": "receivedProduct", "quilos": "kilograms", "Informar a altura do pasto": "enterPastureHeight", "Confirme a movimentação de faixa": "confirmStripMovement", "Informar a nota do pasto": "enterPastureRating"
};

interface MessageBalloonProps {
  text: string;
  pointed?: boolean;
  answer?: boolean;
  url?: string;
}

export const MessageBalloon: React.FC<MessageBalloonProps> = ({
  text,
  pointed = false,
  answer = false,
  url
}) => {
  const { t } = useTranslation();
  const normalizedText = text.trim();
  const translationKey = translationKeys[normalizedText];
  const newBatchMatch = normalizedText.match(/^O novo lote se chamará (.+)$/);
  const routeMatch = normalizedText.match(/^Nesta rota estão os pastos (.+)\.$/);
  const translatedText = translationKey
    ? t(`messageBalloon.${translationKey}`)
    : newBatchMatch
      ? t("messageBalloon.newBatchName", { name: newBatchMatch[1] })
      : routeMatch
        ? t("messageBalloon.routePaddocks", { paddocks: routeMatch[1] })
        : text;

  return (
    <div className={["balloon", pointed && "pointed", answer && "answer"].filter(Boolean).join(" ")}>
      {url ? <a href={url}>{translatedText}</a> : <>{translatedText}</>}
    </div>
  );
};
